import { useEffect, useRef, useState } from "react";
import {
  ALTIN, ALTIN_PARLAK, ALTIN_KOYU, INK, INK_2, INK_3,
  KAGIT, KAGIT_2, CIZGI, DISPLAY, GOVDE, CIKIS, R,
  BLOK, BLOK_2,
} from "../data/constants";

/* =============================================================
   ORTAK YAPI TAŞLARI

   Sitede 1158 satır inline stil vardı ve her sayfa kendi düğmesini,
   kendi başlığını, kendi kartını yeniden icat ediyordu. Bu dosya o
   tekrarları tek yere topluyor: bir düğmenin nasıl göründüğü artık
   tek yerde tanımlı, sekiz sayfada değil.
   ============================================================= */

export const KAP = { maxWidth: 1200, margin: "0 auto", padding: "0 30px" };

/* ---------- görününce yumuşakça yerine oturan sarmalayıcı ----------
   Emniyet zamanlayıcısı ŞART: gözlemci tetiklenmezse (yazdırma, eski
   tarayıcı, sekme arkada) içerik gizli kalmamalı. Bu tuzağa bir kez
   düşüldü ve sayfanın yarısı boş göründü. */
export function Ac({ children, gecikme = 0, style }) {
  const ref = useRef(null);
  const [gor, setGor] = useState(false);
  useEffect(() => {
    const az = window.matchMedia
      && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (az || !("IntersectionObserver" in window)) { setGor(true); return; }
    const el = ref.current;
    if (!el) return;
    const g = new IntersectionObserver(([k]) => {
      if (k.isIntersecting) { setGor(true); g.disconnect(); }
    }, { threshold: 0.06, rootMargin: "0px 0px -6% 0px" });
    g.observe(el);
    const emniyet = setTimeout(() => setGor(true), 1400);
    return () => { g.disconnect(); clearTimeout(emniyet); };
  }, []);
  return (
    <div ref={ref} style={{
      opacity: gor ? 1 : 0,
      transform: gor ? "none" : "translateY(14px)",
      transition: `opacity .36s ${CIKIS} ${gecikme}ms, transform .36s ${CIKIS} ${gecikme}ms`,
      ...style,
    }}>{children}</div>
  );
}

/* ---------- düğme ---------- */
export function Dugme({ tur = "dolu", href, onClick, children, style, ...kalan }) {
  const [ust, setUst] = useState(false);
  const temel = {
    display: "inline-flex", alignItems: "center", gap: 8,
    padding: "12px 20px", borderRadius: 10, border: 0, cursor: "pointer",
    fontFamily: DISPLAY, fontWeight: 600, fontSize: 14.5, textAlign: "center",
    transition: `background .18s ${CIKIS}, color .18s ${CIKIS}, transform .12s ${CIKIS}`,
  };
  const turler = {
    dolu:    { background: ust ? "#000" : INK, color: KAGIT },
    acik:    { background: ust ? INK : "transparent", color: ust ? KAGIT : INK,
               boxShadow: `inset 0 0 0 1.5px ${INK}` },
    altin:   { background: ust ? ALTIN_PARLAK : ALTIN, color: "#140F04" },
    hayalet: { background: ust ? "rgba(251,250,246,.1)" : "transparent", color: KAGIT,
               boxShadow: "inset 0 0 0 1.5px rgba(251,250,246,.26)" },
    beyaz:   { background: KAGIT, color: INK },
  };
  const props = {
    style: { ...temel, ...turler[tur], ...style },
    onMouseEnter: () => setUst(true),
    onMouseLeave: () => setUst(false),
    onMouseDown: (e) => { e.currentTarget.style.transform = "scale(.97)"; },
    onMouseUp: (e) => { e.currentTarget.style.transform = "none"; },
    ...kalan,
  };
  return href
    ? <a href={href} onClick={onClick} {...props}>{children}</a>
    : <button type="button" onClick={onClick} {...props}>{children}</button>;
}

/* ---------- bölüm başlığı ----------
   Bilerek "eyebrow" (küçük büyük harfli üst etiket) YOK: her bölümün
   üstüne etiket koymak sayfayı şablon gibi gösteriyor. Başlık kendi
   işini yapsın. */
export function BolumBas({ baslik, yan, koyu = false }) {
  return (
    <div style={{
      display: "flex", alignItems: "flex-end", justifyContent: "space-between",
      gap: 30, flexWrap: "wrap", marginBottom: 14,
    }}><h2 style={{
        fontSize: "clamp(30px,3.6vw,46px)", maxWidth: "16ch",
        color: koyu ? KAGIT : INK,
      }}>{baslik}</h2>
      {yan && (
        <p style={{
          fontFamily: GOVDE, fontSize: 16.5, maxWidth: "38ch",
          color: koyu ? "rgba(251,250,246,.62)" : INK_2,
        }}>{yan}</p>
      )}
    </div>
  );
}

/* ---------- dizin satırı ----------
   Üçlü eşit kart ızgarası yerine editoryal dizin. Kart ızgarası
   dokuz hizmeti dokuz ayrı kutuya bölüp taramayı zorlaştırıyordu. */
export function Dizin({ children }) {
  return <div style={{ borderTop: `1px solid ${CIZGI}` }}>{children}</div>;
}

export function DizinSatir({ no, baslik, aciklama, etiketler = [], href, onClick }) {
  const [ust, setUst] = useState(false);
  return (
    <a href={href} onClick={onClick}
       onMouseEnter={() => setUst(true)} onMouseLeave={() => setUst(false)}
       style={{
         display: "grid", gridTemplateColumns: "auto 1fr auto", gap: 24,
         alignItems: "baseline", padding: "24px 0 22px",
         borderBottom: `1px solid ${CIZGI}`,
         background: ust ? KAGIT_2 : "transparent",
         transition: `background .2s ${CIKIS}`,
       }}><span style={{ fontFamily: DISPLAY, fontSize: 12.5, fontWeight: 700,
                     color: INK_3, width: 24 }} className="sayi">{no}</span><div><h3 style={{ fontSize: "clamp(20px,2.2vw,25px)" }}>{baslik}</h3>
        {aciklama && (
          <p style={{ fontFamily: GOVDE, fontSize: 15, color: INK_2,
                      marginTop: 6, maxWidth: "54ch" }}>{aciklama}</p>
        )}
        {etiketler.length > 0 && (
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 11 }}>
            {etiketler.map((e) => (
              <span key={e} style={{
                fontFamily: GOVDE, fontSize: 12.5, color: INK_2,
                background: ust ? "#E8E5DA" : KAGIT_2,
                padding: "4px 10px", borderRadius: 999,
              }}>{e}</span>
            ))}
          </div>
        )}
      </div><svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"stroke={ust ? ALTIN : INK_3} strokeWidth="1.4"style={{ alignSelf: "center", flex: "none",
                    transform: ust ? "translateX(5px)" : "none",
                    transition: `transform .2s ${CIKIS}, stroke .2s ${CIKIS}` }}><path d="M5 12h14M13 6l6 6-6 6" /></svg></a>
  );
}

/* ---------- numaralı madde (ilke, adım) ---------- */
export function Madde({ no, baslik, metin, koyu = false }) {
  return (
    <div><span style={{ fontFamily: DISPLAY, fontSize: 12, fontWeight: 700,
                     color: koyu ? ALTIN_PARLAK : ALTIN_KOYU }} className="sayi">{no}</span><h3 style={{ fontSize: 18.5, margin: "11px 0 8px",
                   color: koyu ? KAGIT : INK }}>{baslik}</h3><p style={{ fontFamily: GOVDE, fontSize: 14.5, lineHeight: 1.56,
                  color: koyu ? "rgba(251,250,246,.62)" : INK_2 }}>{metin}</p></div>
  );
}

/* ---------- koyu blok (kanıt, kapanış) ---------- */
export function KoyuBlok({ children, style }) {
  return (
    <section style={{ background: BLOK, color: KAGIT, padding: "92px 0", ...style }}><div style={KAP}>{children}</div></section>
  );
}

export { ALTIN, ALTIN_PARLAK, ALTIN_KOYU, INK, BLOK, BLOK_2, INK_2, INK_3, KAGIT, KAGIT_2, CIZGI, DISPLAY, GOVDE, CIKIS, R };
